/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchComplianceReportRes {
    getFixupPrototypeFunction() { return PatchComplianceReportRes.fixupPrototype; }

    static newInstance(model: Partial<PatchComplianceReportRes>): PatchComplianceReportRes {
        let obj = Object.assign(new PatchComplianceReportRes(), model);
        PatchComplianceReportRes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchComplianceReportRes>): PatchComplianceReportRes {
        if (!model) return null;
        return PatchComplianceReportRes.newInstance(<PatchComplianceReportRes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchComplianceReportRes) {
        if (!obj) return;

        models.PatchComplianceReportRes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchComplianceReportRes): boolean {
        Object.setPrototypeOf(obj, PatchComplianceReportRes.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * status response
     */
    status: string;

    /**
     * message response
     */
    message: string;

    /**
     * compliance data
     */
    data: any;

}
